import ApplicationController from '../application_controller'

class AttributeFormController extends ApplicationController {
  connect () {
    window.Forms.initDatePickers('.modal')
    window.Forms.initSelect2('.modal')

    let currentFieldWrapper = null
    let currentFieldInputs = null

    this.element.addEventListener('submit', (e) => {
      if (currentFieldWrapper) {
        const fieldValueEls = this.element.querySelectorAll('[name^="delayed_update[field_value]"]')
        fieldValueEls.forEach((el) => {
          const inWrapper = currentFieldWrapper.contains(el)
          if (!inWrapper) {
            el.disabled = true
            el.setAttribute('disabled', 'disabled')
            if (el.dataset?.select2) $(el).prop('disabled', true)
            return
          }

          el.disabled = false
          el.removeAttribute('disabled')
          if (el.dataset?.select2) $(el).prop('disabled', false)

          if (el.tagName === 'INPUT' && el.type === 'hidden' && (el.value === null || el.value === undefined || el.value === '')) {
            el.disabled = true
            el.setAttribute('disabled', 'disabled')
          }
        })
      }

      const submitTag = this.element.querySelector('[type="submit"]')
      submitTag.disabled = true
      submitTag.classList.add('disabled')
    }, true)

    $('.use-geocomplete').geocomplete({ map: false })

    const disableInputs = (inputs) => {
      if (!inputs) return
      inputs.forEach((el) => {
        el.disabled = true
        el.setAttribute('disabled', 'disabled')
        if (el.dataset?.select2) $(el).prop('disabled', true)
      })
    }

    const enableInputs = (inputs) => {
      if (!inputs) return
      inputs.forEach((el) => {
        el.disabled = false
        el.removeAttribute('disabled')
        if (el.dataset?.select2) $(el).prop('disabled', false)
      })
    }

    document.getElementById('delayed_update_field_name').addEventListener('change', (e) => {
      if (currentFieldWrapper) currentFieldWrapper.classList.add('hidden')
      disableInputs(currentFieldInputs)

      if (e.target.value === null || e.target.value === undefined || e.target.value === '') return

      currentFieldWrapper = document.getElementById(e.target.value)
      if (!currentFieldWrapper) return
      currentFieldInputs = currentFieldWrapper.querySelectorAll('input, select, textarea')

      currentFieldWrapper.classList.remove('hidden')
      enableInputs(currentFieldInputs)
    })

    document.getElementById('delayed_update_field_name').dispatchEvent(new Event('change'))
  }
}

export default AttributeFormController
